import React from "react";
import "./AboutConference.css";
import bnmit from "../../assets/images/bnmit.webp";
import blore from "../../assets/images/blore.webp";
import { MdLocationOn } from "react-icons/md";
const AboutConference = () => {
  return (
    
    <div className="AboutConference">
      
      <div className="abt-content">

        {/*<span style={{ fontSize: "3.5rem" }}>About The Conference</span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            textAlign: "justify",
          }}
        >
          <p>
            
           In view of the grand success of the third International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics
           (ICIITCEE 2025) organized by BNM Institute of Technology, Bengaluru, India on 16<sup>th</sup> and 17<sup>th</sup> January 2025, the management and the organizers are coming
with the fourth IEEE ICIITCEE 2026. The conference received overwhelming response from researchers, academicians and industry. Totally 500 papers were accepted, presented, and published in IEEE Xplore. This year, 4<sup>th</sup> ICIITCEE 2026 will be held on 22 and 23 January 2026. This conference
will feature a comprehensive technical program including several special sessions and workshops. The goal of ICIITCEE 2026 is to provide an outstanding
forum for academicians, researchers, practitioners, policymakers, and students to exchange ideas, techniques and tools, raise awareness, and share
experiences related to all practical and theoretical aspects of intelligence and innovations in engineering.<br/>
ICIITCEE 2026 focuses on issues and solutions involving Intelligent and Innovative Technologies in Computing, Electrical and Electronics. Developments in
the field of Computing, Electrical and Electronics are very complex and advance rapidly as changes occur on day-to-day basis. It is very difficult to make it
available to all stakeholders (researchers, academicians, students, industrialists and society). Hence, the objectives of the conference are:
          </p>
          <ul style={{ marginLeft: "5rem" }}>
            <li>
              &mdash;&nbsp;&nbsp;To provide a platform for stakeholders to meet
              and share ideas, views and new findings in the field of
              contemporary Computing, Electrical and Electronics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To strengthen the relationship with industries
              and academic institutions of Karnataka and Bengaluru and, with
              the rest of the world.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To provide a space for students and researchers
              to meet, discuss, and learn with experts in the related field.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To bridge the gap between the industry and
              academics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To promote a high level of interaction among
              stakeholders in theoretical, experimental, and applied concepts in
              the field of Computing, Electrical and Electronics.
            </li>
          </ul>
        </div>*/}
        <div className="venue-container">
          <div className="venueimg">
  <img src={bnmit} alt="BNMIT" />
  <p style={{ display: "inline-flex", alignItems: "center", gap: "0.3rem" }}>
  <MdLocationOn color="#FF0000" size="1.3rem" />
  12th Main Road, 27th Cross, Banashankari II Stage, Bengaluru, Karnataka 560070
</p>
</div>
          <div className="venue-content">
            <span style={{ fontSize: "2.8rem" }}>Conference Venue – B.N.M. Institute of Technology (BNMIT)</span>
            <p>
            B.N.M. Institute of Technology (BNMIT) is a premier autonomous engineering institution in Bengaluru, established in 2001 and highly regarded for its academic excellence and industry-aligned education. The campus, set in a green and vibrant environment in Banashankari, offers modern infrastructure with advanced laboratories, digital classrooms, dedicated seminar halls, and a large auditorium suited for high-profile events and conferences.

Recognized with a NAAC “A” grade and NBA-accredited programs, BNMIT is known for its emphasis on innovation, professional development, and strong industry linkages. Its robust placement ecosystem and holistic learning culture make it an ideal venue for national and international academic gathering
            </p>
          </div>
        </div>
   <div className="venue-container">
  <div className="venueimg">
    <img src={blore} alt="Bengaluru" />
    <p style={{ textAlign: "center" }}>Bengaluru, Capital of Karnataka</p>
  </div>

  <div className="venue-content">
    <span style={{ fontSize: "3.5rem" }}>Bengaluru</span>

    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      
      <div>
        <p style={{ fontWeight: "bold" }}>Climate</p>
        <p>
          Bengaluru enjoys a pleasant tropical climate year-round with warm
          summers, refreshing monsoons and mild winters.
        </p>
      </div>

      <div>
        <p style={{ fontWeight: "bold" }}>City Overview</p>
        <p>
          One of India’s largest and most vibrant cities, known for its
          diverse population and thriving culture.
        </p>
      </div>

      <div>
        <p style={{ fontWeight: "bold" }}>Language</p>
        <p>
          The official language is Kannada, and English is widely spoken
          throughout the city.
        </p>
      </div>

      <div>
        <p style={{ fontWeight: "bold" }}>Transport</p>
        <p>
          Well-connected by buses, taxis, auto-rickshaws and the Namma Metro,
          with excellent rail and air links.
        </p>
      </div>

    </div>
  </div>
</div>

</div>
</div>
  );
};

export default AboutConference;